 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];

 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		// chunk prefetching for javascript
 		prefetchChunks.forEach(function(chunkId) {
 			if(installedChunks[chunkId] === undefined) {
 				installedChunks[chunkId] = null;
 				var link = document.createElement('link');

 				if (__webpack_require__.nc) {
 					link.setAttribute("nonce", __webpack_require__.nc);
 				}
 				link.rel = "prefetch";
 				link.as = "script";
 				link.href = jsonpScriptSrc(chunkId);
 				document.head.appendChild(link);
 			}
 		});
 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		35: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"monaco-editor","1":"vendors~AddDrawingModal~ChallengeEditView~ReadOnlyEditorView","2":"vendors~ChallengeGroupListView~CompanyList~VacancyListView","3":"ChatComponent","4":"CompanyList~VacancyListView","5":"PublicUserProfile","6":"vendors~CampaignDetails~ChallengeEditView","7":"vendors~ChatComponent~ChatView","8":"vendors~DashboardView~PublicUserProfile","10":"AddDrawingModal","11":"CampaignDetails","12":"CampusChallengeView","13":"ChallengeAnalysis","14":"ChallengeEditView","15":"ChallengeGroupListView","16":"ChatView","17":"CompanyList","18":"CreatorsLounge","19":"DashboardView","20":"DirectLinkChallengeEditView","21":"LeaderboardView","22":"Login","23":"NewCompanyProfileView","24":"NewsListView","25":"NewsPostView","26":"ReadOnlyEditorView","27":"ResumeView","28":"RewardExchangeView","29":"RewardGroupListView","30":"UserProfileView","31":"VacancyListView","32":"VacancyView","36":"vendors~CampaignDetails","37":"vendors~ChallengeEditView","38":"vendors~CompanyList","39":"vendors~VacancyView"}[chunkId]||chunkId) + "." + {"0":"a35694e687455190549e","1":"72f57e446534a5a56fa3","2":"660fe10d16e94853249c","3":"672c9919e961d08a8f64","4":"40b25af04cf1e10c2c1a","5":"01dae8314fa1646a0e3b","6":"2ab31fdfa01545cdb36b","7":"10d5462d751eda106ba2","8":"69e3380d64e92cf96118","9":"1dd29be387f81fcb32d9","10":"2aed954f201a61c0e70d","11":"12f902b87b064093a306","12":"240a45e3af4279977b9b","13":"f686175c77e6fb349fae","14":"3172aa2e69e38cb4b5ca","15":"79cd126e0691ab3d0971","16":"0fed91d325820e9819ac","17":"2cd72cb9f55d22012dfe","18":"a92841ae8b93e3d3d2d5","19":"f0c13a6d454879c871ac","20":"dfef17eadceb9a70c699","21":"75c35485939e83743c1d","22":"b18041d918988a31b900","23":"9fcb51f6fb1c672e08eb","24":"5400c18d6ff3796beec0","25":"e6a7ba65cc2aa79fadeb","26":"7e97a8f0e25714144966","27":"3fbecfa3a54a2dc84099","28":"70363535bbda030ed659","29":"f42588904b9c2a2ea414","30":"222230243d603abeab29","31":"5664a242a42aa8d5b02c","32":"f0b1fd27b19089ff7eb4","36":"0d886609c9c9424eba6e","37":"f3b086cad90550f636d5","38":"f40d5d196464765d62d1","39":"de5110ebe56649ad8e95","40":"611a543d627f34650de9","41":"29af6ae83ad284daf3cf","42":"40502b46f34502ccff09","43":"dd2fd229d9637716dcfd","44":"0cce64e29cb875bcc10b","45":"cfe901dcf2ba2cac0b9d","46":"a66dc055272cbd25ec96","47":"09d07b0f02e6dbaf250d"}[chunkId] + ".bundle.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = self["webpackJsonp"] = self["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	var startupResult = (function() {
 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 497);
 	})();

 	webpackJsonpCallback([[], {}, 0, [0,1,6,37,14,36,11,2,38,4,17,26,31,7,3,16,8,5,19,15,39,32,12,13,18,20,21,22,23,24,25,27,28,29,30]]);
 	return startupResult;
